import styled from "styled-components"
import { theme } from "Theme"

const StyledLink = styled.a`
  position: relative;
  color: ${theme.colors.primary.base};
  font-size: 90%;
  text-decoration: underline;
  font-weight: bold;
`

export default StyledLink
